import { PayModeSelectionSuccessContainer } from 'src/containers';

export const PayModeSelectionSuccess = () => <PayModeSelectionSuccessContainer />;
